<template lang="pug">
  .page.page_offset_top.page_offset_bottom
    .page-meta
      .container
        .page-meta__inner.page-meta__inner_top
          breadcrumbs
    .page-rules
      .container
        h1.title.title_size_l.text_center.page-rules__title Правила использования сервиса
        p.text_center.page-rules__desc We’re happy to&nbsp;answer any questions you may have, just send&nbsp;us a&nbsp;message via our in-app support chat.
        .rules-list
          .rules-item(v-for="rule in rules")
            .rules-item__row
              .rules-item__image
                .rules-item__icon(:class="[`rules-item__icon_${rule.icon}`]")
              .rules-item__content
                h2.rules-item__title {{rule.title}}
                p.rules-item__text(v-html="rule.text")

</template>

<script>
export default {
  name: 'Rules',
  data () {
    return {
      rules: [
        {
          icon: 'requirements',
          title: 'Требования к пользователю',
          text: 'Для аренды автомобилей мы принимаем с 21 года и с водительским стажем два года.<br> Для аренды автомобилей бизнес-класса вам должно 25 лет и водительский стаж пять лет.'
        },
        {
          icon: 'transfer',
          title: 'Передача автомобиля посторонним',
          text: 'Нельзя передавать управление автомобилем другому водителю. Это небезопасно и страховка в этом случае не будет действовать. Также за передачу предусмотрен штраф, а все убытки во время аренды, будете оплачивать вы.'
        },
        {
          icon: 'area',
          title: 'Зоны передвижения и завершения аренды',
          text: 'Нельзя передавать управление автомобилем другому водителю. Это небезопасно и страховка в этом случае не будет действовать. Также за передачу предусмотрен штраф, а все убытки во время аренды, будете оплачивать вы.'
        },
        {
          icon: 'gas-station',
          title: 'Заправка и бонусы',
          text: 'Вы можете самостоятельно заправить автомобиль. Во время аренды в приложении появится кнопка «заправка». Нажмите на кнопку и приложение построит маршрут до ближайшей АЗС. Или выберите АЗС из списка на свое усмотрение. Когда вы подъедите к колонке, появится экран подсказок и пин-код топливной карты. Заправьте бак нужным количествам топлива и получите 120 бонусных рублей. Не завершайте аренду, когда на приборной панели горит индикатор заправки, за это будет штраф.'
        },
        {
          icon: 'insurance',
          title: 'Страховка и расширенное КАСКО',
          text: 'Все автомобили застрахованы по КАСКО. Вам ничего не придется платить, если в ДТП вы не виноваты. Если авария произошла по вашей вине, то сумма выплаты 30 000 рублей. Для сервиса BelkaBlack 50 000 рублей. Подключите расширенное КАСКО и при любой аварии вы заплатите не больше 15 000 рублей.'
        },
        {
          icon: 'defect',
          title: 'Осмотр автомобиля на повреждения',
          text: 'Иногда на автомобиле могут быть повреждения или отсутствие какого-либо элемента, например ковриков. Перед началом аренды обязательно сфотографируйте и отметьте в приложении возможные недочеты. Если вы не отметите неисправности, то ответственность за них ляжет на вас.'
        },
        {
          icon: 'pdd',
          title: 'Соблюдение ПДД и правил парковки',
          text: 'Все автомобили застрахованы по КАСКО. Вам ничего не придется платить, если в ДТП вы не виноваты. Если авария произошла по вашей вине, то сумма выплаты 30 000 рублей. Для сервиса BelkaBlack 50 000 рублей. Подключите расширенное КАСКО и при любой аварии вы заплатите не больше 15 000 рублей.'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Rules.vue